import { logError } from "@/utils/loggers";
import AppShell from "./AppShell";
import { ErrorBoundaryFallback } from "./Error";
import * as Sentry from "@sentry/react";
export const Page = ({
  children,
  className,
}: {
  children: React.ReactNode;
  className?: string;
}) => {
  return (
    <AppShell className={className}>
      <Sentry.ErrorBoundary
        fallback={ErrorBoundaryFallback}
        showDialog={false}
        onError={(error, componentStack, eventId) => {
          logError({
            userInfo: error,
            devInfo: { componentStack, eventId },
          });
        }}
      >
        {children}
      </Sentry.ErrorBoundary>
    </AppShell>
  );
};
